"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTypeOptions = exports.ProjectTypeGroup = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
var ProjectTypeGroup;
(function (ProjectTypeGroup) {
    ProjectTypeGroup["AIAgent"] = "AI Agent";
    ProjectTypeGroup["M365Apps"] = "Apps for Microsoft 365";
})(ProjectTypeGroup = exports.ProjectTypeGroup || (exports.ProjectTypeGroup = {}));
class ProjectTypeOptions {
    static groupName(group) {
        switch (group) {
            case ProjectTypeGroup.AIAgent:
                return (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.createGroup.aiAgent");
            case ProjectTypeGroup.M365Apps:
                return (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.createGroup.m365Apps");
        }
    }
    static teamsAgentsAndApps(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.teamsOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(microsoft365-agents-toolkit-teams) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.teamsAgentsAndApps.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.teamsAgentsAndApps.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.M365Apps),
        };
    }
    static outlookAddin(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.outlookAddinOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(mail) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.outlookAddin.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.outlookAddin.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.M365Apps),
        };
    }
    static officeMetaOS(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.officeMetaOSOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(microsoft365-agents-office) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.officeAddin.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.officeAddin.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.M365Apps),
        };
    }
    static officeAddin(platform = teamsfx_api_1.Platform.VSCode) {
        if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.OfficeMetaOS)) {
            return this.officeMetaOS(platform);
        }
        else {
            return this.outlookAddin(platform);
        }
    }
    static declarativeAgent(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.copilotAgentOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-agent) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.AIAgent),
        };
    }
    static customEngineAgent(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.customEngineAgentOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-custom-copilot) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.AIAgent),
        };
    }
    static graphConnector(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.graphConnectorOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-graph-connector) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.createGraphConnector.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.createGraphConnector.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.AIAgent),
        };
    }
    static startWithGithubCopilot() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.HideGitHubCopilotPreviewTag)
            ? undefined
            : (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview");
        return {
            id: ProjectTypeOptions.startWithGithubCopilotOptionId,
            label: `$(question) ${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotHelp.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotHelp.detail"),
            groupName: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotGroup.title"),
            description,
        };
    }
}
exports.ProjectTypeOptions = ProjectTypeOptions;
ProjectTypeOptions.copilotAgentOptionId = "copilot-agent-type";
ProjectTypeOptions.customEngineAgentOptionId = "custom-engine-agent-type";
ProjectTypeOptions.teamsOptionId = "teams-agent-and-app-type";
ProjectTypeOptions.outlookAddinOptionId = "outlook-addin-type";
ProjectTypeOptions.officeMetaOSOptionId = "office-meta-os-type";
ProjectTypeOptions.graphConnectorOptionId = "graph-connector-type";
ProjectTypeOptions.startWithGithubCopilotOptionId = "start-with-github-copilot";
//# sourceMappingURL=ProjectTypeOptions.js.map